module.exports = __webpack_public_path__ + "static/media/1_Protokol bez EGN-compressed_20160622.edc9225f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/1_Protokol bez EGN-compressed_20160622.pdf
// module id = 162
// module chunks = 0